<template>
  <div id="noticias">
    <vue-headful :title="noticia.title" :lang="noticia.language" />
    <titulo></titulo>
    <div class="container">
      <div class="card" v-if="!perg">
        <!--<img v-if="noticia.capa" :src="'/images/' + noticia.capa" class="card-img-top" :alt="noticia.title">-->
        <div class="card-body">
          <!--<h5 class="card-title">{{noticia.title}}</h5>-->
          <div class="imagesContent" style="word-break: break-all;" v-html="decodeHTMLEntities(noticia.content)"></div>
        </div>
      </div>
      <div v-else :class="{'b-cinzento': dt.show, 'm-v-10 pr': 1}" v-for="(dt, index) in perguntas" :key="index" style="border-bottom: solid 2px rgb(242,242,242);padding:10px 80px 10px 20px">
        <i v-if="!dt.show" @click="mostrar(index)" style="width:60px;text-align:center;position:absolute;top:0px;right:0px;height: 60px; background:rgb(242,242,242);line-height:60px;" class="fas fa-arrow-down mao"></i>
          <i v-else @click="dt.show=0" style="width:60px;text-align:center;position:absolute;top:0px;right:0px;height: 60px;line-height:60px;color:#fff;" class="fas fa-times mao b-laranja"></i>
        <div :class="{'text-left pr col-lg-12': 1, 'laranja': dt.show}" style="min-height: 40px;" v-html="dt.p"></div>
        <div v-if="dt.show" class="text-justify col-lg-12" v-html="dt.r"></div>
      </div>
    </div>
    <pesquisa></pesquisa>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import titulo from '@/components/titulo'
import pesquisa from '@/components/pesquisa'

export default {
  components: { titulo, pesquisa },
  data () {
    return {
      noticia: {},
      perguntas: [],
      perg: false,
      lang: ''
    }
  },
  watch: {
    '$route' (b, c) {
      this.SET_LOAD(true)
      this.init()
    }
  },
  mounted () {
    this.SET_LOAD(true)
    this.init()
  },
  methods: {
    ...mapMutations([
      'SET_LOAD',
      'SET_TITULO',
      'SET_SUBTITULO'
    ]),
    init () {
      if (this.$store.state.option1) {
        this.lang = this.$store.state.lang
        this.axios.get('/pages/' + this.$route.params.id).then((res) => {
          if (res.data.content.indexOf('#ask') !== -1) {
            if (this.$store.state.option['ask-' + res.data.language]) {
              this.perguntas = JSON.parse(this.$store.state.option['ask-' + res.data.language]).map(a => { return { r: a.r, p: a.p, show: 0 } })
            } else {
              this.perguntas = []
            }
            this.perg = true
          } else {
            this.perg = false
          }
          this.noticia = res.data
          this.SET_TITULO(this.noticia.title)
          this.SET_SUBTITULO(this.noticia.subtitle)
          this.SET_LOAD()
        }, (er) => {
          this.$router.replace('/404', () => {})
        })
      } else {
        this._.delay(this.init, 100)
      }
    },
    mostrar (index) {
      this.perguntas = this.perguntas.map(a => { return { r: a.r, p: a.p, show: 0 } })
      this.perguntas[index].show = 1
    },
    decodeHTMLEntities (text) {
      let entities = {
        'amp': '&',
        'apos': '\'',
        '#x27': '\'',
        '#x2F': '/',
        '#39': '\'',
        '#47': '/',
        'lt': '<',
        'gt': '>',
        'nbsp': ' ',
        'quot': '"'
      }
      if (text) {
        return text.replace(/&([^;]+);/gm, (match, entity) => {
          return entities[entity] || match
        })
      }
      return ''
    }
  }
}
</script>
